import { Usuario } from '../vo/usuario';

export class TokenInfo {
	constructor(
		public tokenAcess: string,
		public tokenRefresh: string){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/token-info.ts